import logo from '../asset/images/logo.svg';
import upload from '../asset/images/uploadIcon.png'
import theoryIcon from '../asset/images/theoryIcon.svg'
import codingIcon from '../asset/images/codingIcon.svg'
import analyticalIcon from '../asset/images/analyticalIcon.svg'
import timerIcon from '../asset/images/timerIcon.svg'
import thankyou from '../asset/images/thankyou.svg'
import questionairemutedIcon from '../asset/images/questionaireIcon.svg'
import testmutedIcon from '../asset/images/TestIcon.svg'
import candidateColorIcon from '../asset/images/candidateICon.svg'
import questionaireColorIcon from '../asset/images/questiona-color.svg'
import testColorIcon from '../asset/images/test-color.svg'
import candidatemutedIcon from '../asset/images/candidate-muted-icon.svg'
import imageIcon from '../asset/images/imageIcon.svg'
import deleteImg from '../asset/images/deleteImg.svg'
import wrongUrl from '../asset/images/invitationmutedIcon.png'
import timeover from '../asset/images/timeover.svg'
import orgwithColorICon from '../asset/images/orgwithColorICon.png'
import orgwithoutColorICon from '../asset/images/orgwithoutColorICon.png'

import invitationmutedIcon from '../asset/images/invitationmutedIcon.png'
import invitationColorICon from '../asset/images/invitationColorICon.png'
import usermutedIcon from '../asset/images/user.png'
import userColorIcon from '../asset/images/userColorIcon.png'
export const Images = {
  logo,
  thankyou,
  deleteImg,
  wrongUrl,
  timeover
};
export const Icons = {
  upload,
  codingIcon,
  analyticalIcon,
  theoryIcon,
  timerIcon,
questionaireColorIcon,
candidateColorIcon,
testColorIcon,
questionairemutedIcon,
candidatemutedIcon,
testmutedIcon,
imageIcon,
invitationmutedIcon,
invitationColorICon,
usermutedIcon,
userColorIcon,
orgwithColorICon,
orgwithoutColorICon
};
